import { ICalcBestCPC, ICalcLimitedCPC, ICalcTargetCPC } from "../../../../types/metrics.types"
import { ITargetDataForTable } from "../../types/sbTarget.types"

export interface ICampaignAov {
  campaignName: string
  value: number
}

export interface ITargetMetricsSettings {
  defaultBid: number
  minTargetCPC: number
  maxTargetCPC: number
  limitedCPCConditions: ICalcLimitedCPC["conditions"] | null
  aovValue: number
}

export interface ITargetMetricsCalculators {
  calcTargetCPC: (params: ICalcTargetCPC) => number
  calcBestCPC: (params: ICalcBestCPC) => number
  calcLimitedCPC: (params: ICalcLimitedCPC) => number
}

export function findCampaignAov(
  aovs: ICampaignAov[] | undefined,
  campaignName: string
): ICampaignAov | undefined {
  if (!aovs) {
    return undefined
  }

  return (
    aovs.find((aov) => campaignName.toLowerCase().includes(aov.campaignName.toLowerCase())) ||
    aovs.find((aov) => aov.campaignName.toLowerCase() === "all")
  )
}

export function applyTargetMetrics(
  targets: ITargetDataForTable[],
  settings: ITargetMetricsSettings,
  calculators: ITargetMetricsCalculators
): ITargetDataForTable[] {
  return targets.map((target) => applyMetricsToTarget(target, settings, calculators))
}

function applyMetricsToTarget(
  target: ITargetDataForTable,
  settings: ITargetMetricsSettings,
  calculators: ITargetMetricsCalculators
): ITargetDataForTable {
  const targetCPC = calculators.calcTargetCPC({
    targetAcos: target.targetAcos,
    orders: target.orders,
    impressions: target.impressions,
    aovValue: settings.aovValue,
    clicks: target.clicks,
    bidInAmazon: target.bid,
    currentAcos: target.acos,
    sales: target.sales,
    defaultBid: settings.defaultBid,
  })

  const bestCPC = calculators.calcBestCPC({
    targetCVRCPC: target.targetCVRCPC,
    targetCPC,
    bestCVRCPC: target.bestCVRCPC,
  })

  const targetWithCpc = { ...target, targetCPC, bestCPC }

  if (!settings.limitedCPCConditions) {
    return targetWithCpc
  }

  return {
    ...targetWithCpc,
    limitedCPC: calculators.calcLimitedCPC({
      defaultBid: settings.defaultBid,
      clicks: target.clicks,
      conditions: settings.limitedCPCConditions,
      currentAcos: target.acos,
      targetAcos: target.targetAcos,
      orders: target.orders,
      impressions: target.impressions,
      aovValue: settings.aovValue,
      bidInAmazon: target.bid,
      sales: target.sales,
      minTargetCPC: settings.minTargetCPC,
      maxTargetCPC: settings.maxTargetCPC,
    }),
  }
}
